import { useTranslation } from '@conekta/cronos/i18n';

import type { FC } from 'react';
import './styles.scss';

export const TestBar: FC = () => {
  const { t } = useTranslation();
  return (
    <div className="checkout-test-bar">
      <div className="checkout-test-bar__inner">{t('hostedCheckout.testbar.message')}</div>
    </div>
  );
};
